import { SubscriptionV2 } from '../../../../types/firm';
import { Progress } from '@cimplico/components';
import { formatDate } from '../../../../utilities/formatting';

type QuotaUsageSectionProps = {
    subscription: SubscriptionV2;
};

function QuotaUsageSection({ subscription }: QuotaUsageSectionProps): JSX.Element {
    const percent = (subscription.activeEntities / subscription.totalActiveEntityAllocation) * 100;

    return (
        <div className="flex flex-wrap gap-x-16 gap-y-6">
            <div className="w-[400px]">
                <h3 className="text-contentPrimary font-bold">Active Entity Usage</h3>
                <p className="text-sm text-contentSecondary mt-1">
                    See your active entity allowance and current usage. An entity becomes active when a workpaper is made inside of it. You
                    will need to manually deactivate entities that you no longer want to count towards your usage.
                </p>
            </div>
            <div className="flex-none w-full md:flex-1 md:w-auto flex flex-col gap-2">
                <p className="text-contentPrimary text-sm font-bold">Remaining entities</p>
                <Progress percent={percent} type={'bar'} />
                <p className="text-xs text-gray-600 dark:text-gray-400">
                    {subscription.activeEntities} of {subscription.totalActiveEntityAllocation} used
                </p>
                <p className="text-contentPrimary text-sm font-bold mt-1">Next quota recount</p>
                <p className="text-sm text-contentSecondary">{formatDate(subscription.nextQuotaRecount || new Date())}</p>
            </div>
        </div>
    );
}

export default QuotaUsageSection;
